export const en = {
  'deadlines.title': 'Deadlines',
  'deadlines.description': 'Your monthly finance checklist: what is due, what is done, and who answers for it.',
  'deadlines.checklist': 'Checklist',
  'deadlines.overdue': 'Overdue',
  'deadlines.dueToday': 'Due today',
  'deadlines.dueIn.one': 'Due in {count} day',
  'deadlines.dueIn.other': 'Due in {count} days',
  'deadlines.overdueBy.one': '{count} day overdue',
  'deadlines.overdueBy.other': '{count} days overdue',
  'deadlines.dueOn': 'Due {date}',
  'deadlines.empty': 'No deadlines this month.',
  'deadlines.emptyHint': 'Add the dates your accountant works to, and Bulk reminds the right people before each one.',
  'deadlines.markDone': 'Done',
  'deadlines.skip': 'Skip',
  'deadlines.reopen': 'Reopen',
  'deadlines.doneBy': 'Done by {name}, {date}',
  'deadlines.skippedBy': 'Skipped by {name}, {date}',
  'deadlines.completeTitle': 'Mark “{title}” done',
  'deadlines.skipTitle': 'Skip “{title}” this month',
  'deadlines.note': 'Note',
  'deadlines.file': 'File',
  'deadlines.fileHint': 'A PDF or a photo, up to 10 MB, such as the filed statement.',
  'deadlines.fileTooLarge': 'The file is larger than 10 MB',
  'deadlines.markedDone': 'Marked done',
  'deadlines.skippedDone': 'Skipped for this month',
  'deadlines.reopened': 'Reopened',
  'deadlines.openFile': 'Open the attached file',
  'deadlines.recurring': 'Recurring deadlines',
  'deadlines.recurringHint': 'Each one appears on the checklist every month.',
  'deadlines.noneYet': 'No recurring deadlines yet.',
  'deadlines.add': 'Add deadline',
  'deadlines.edit': 'Edit deadline',
  'deadlines.field.title': 'What',
  'deadlines.field.day': 'Day of the month',
  'deadlines.lastDay': 'Last day of the month',
  'deadlines.everyDay': 'Every month, day {day}',
  'deadlines.everyLastDay': 'Every month, last day',
  'deadlines.field.note': 'Note',
  'deadlines.field.responsible': 'Who answers for it',
  'deadlines.responsible.managers': 'Everyone who manages finance',
  'deadlines.responsible.roles': 'A role',
  'deadlines.responsible.people': 'A person',
  'deadlines.field.reminders': 'Remind',
  'deadlines.remind.7': 'A week before',
  'deadlines.remind.3': '3 days before',
  'deadlines.remind.1': 'The day before',
  'deadlines.remind.0': 'On the day',
  'deadlines.noReminders': 'No reminders',
  'deadlines.switchOff': 'Switch off',
  'deadlines.switchedOff': 'Deadline switched off',
  'deadlines.created': 'Deadline added',
  'deadlines.updated': 'Deadline saved',
  'deadlines.suggestions': 'Suggestions',
  'deadlines.suggestionsHint': 'Common monthly finance tasks. Confirm the day with your accountant before relying on it: these are not legal deadlines.',
  'deadlines.suggest.statement': 'Download and file last month’s statement',
  'deadlines.suggest.reconcile': 'Reconcile bank payouts with the ledger',
  'deadlines.suggest.invoices': 'Issue tax invoices on rs.ge',
  'deadlines.suggest.refunds': 'Review pending refunds',
  'deadlines.addSuggestion': 'Add',
  'deadlines.next': 'Next deadlines',
  'deadlines.seeAll': 'All deadlines',
  'deadlines.noneUpcoming': 'Nothing is due.',
  'deadlines.setUp': 'Set up deadlines',
  'deadlines.close.button': 'Close month',
  'deadlines.close.confirmTitle': 'Close {month}?',
  'deadlines.close.confirmBody': 'Its payroll and this checklist freeze until an owner or admin reopens it.',
  'deadlines.close.done': 'Month closed',
  'deadlines.close.closedBy': 'Closed by {name}, {date}. Its payroll and checklist are frozen.',
  'deadlines.close.tasksFirst': 'Mark every task done or skipped to close the month.',
  'deadlines.close.reopenButton': 'Reopen month',
  'deadlines.close.reopenTitle': 'Reopen {month}',
  'deadlines.close.reopenReason': 'Why',
  'deadlines.close.reopenHint': 'Kept in the audit log.',
  'deadlines.close.reopened': 'Month reopened',
  'deadlines.close.reopenedBy': 'Reopened by {name}, {date}: {reason}',
  'deadlines.close.afterClose': 'Paid online after the month closed',
  'deadlines.close.afterCloseHint': 'The bank dated these payments in this month and confirmed them after it closed. Each shows the date it is booked on.',
  'deadlines.closing': 'Closing a month',
  'deadlines.closing.hint': 'A closed month freezes its payroll and this checklist. Accountants, owners and admins close a month once it is over and every task is done or skipped; owners and admins reopen it.',
  'deadlines.late.label': 'When the bank confirms an online payment dated in a closed month',
  'deadlines.late.FLAG': 'Keep its date and flag it on the closed month',
  'deadlines.late.NEXT_OPEN_MONTH': 'Book it at the start of the next open month',
  'deadlines.late.saved': 'Saved',
};

export const ka: Record<keyof typeof en, string> = {
  'deadlines.title': 'ვადები',
  'deadlines.description': 'თქვენი ყოველთვიური ფინანსური ჩამონათვალი: რისი ვადა მოდის, რა შესრულდა და ვინ არის პასუხისმგებელი.',
  'deadlines.checklist': 'ჩამონათვალი',
  'deadlines.overdue': 'ვადაგადაცილებული',
  'deadlines.dueToday': 'ვადა დღესაა',
  'deadlines.dueIn.one': 'ვადამდე {count} დღე',
  'deadlines.dueIn.other': 'ვადამდე {count} დღე',
  'deadlines.overdueBy.one': 'ვადა გადაცილებულია {count} დღით',
  'deadlines.overdueBy.other': 'ვადა გადაცილებულია {count} დღით',
  'deadlines.dueOn': 'ვადა: {date}',
  'deadlines.empty': 'ამ თვეში ვადები არ არის.',
  'deadlines.emptyHint': 'დაამატეთ თარიღები, რომლებითაც თქვენი ბუღალტერი მუშაობს, და Bulk თითოეულის წინ შეახსენებს სწორ ადამიანებს.',
  'deadlines.markDone': 'შესრულდა',
  'deadlines.skip': 'გამოტოვება',
  'deadlines.reopen': 'ხელახლა გახსნა',
  'deadlines.doneBy': 'შეასრულა {name}, {date}',
  'deadlines.skippedBy': 'გამოტოვა {name}, {date}',
  'deadlines.completeTitle': '„{title}“ — შესრულებულად მონიშვნა',
  'deadlines.skipTitle': '„{title}“ — ამ თვეში გამოტოვება',
  'deadlines.note': 'შენიშვნა',
  'deadlines.file': 'ფაილი',
  'deadlines.fileHint': 'PDF ან ფოტო, მაქსიმუმ 10 მბ, მაგალითად შეტანილი ამონაწერი.',
  'deadlines.fileTooLarge': 'ფაილი 10 მბ-ზე დიდია',
  'deadlines.markedDone': 'მონიშნულია შესრულებულად',
  'deadlines.skippedDone': 'ამ თვეში გამოტოვებულია',
  'deadlines.reopened': 'ხელახლა გაიხსნა',
  'deadlines.openFile': 'მიმაგრებული ფაილის გახსნა',
  'deadlines.recurring': 'განმეორებადი ვადები',
  'deadlines.recurringHint': 'თითოეული ყოველთვე ჩნდება ჩამონათვალში.',
  'deadlines.noneYet': 'განმეორებადი ვადები ჯერ არ არის.',
  'deadlines.add': 'ვადის დამატება',
  'deadlines.edit': 'ვადის რედაქტირება',
  'deadlines.field.title': 'რა',
  'deadlines.field.day': 'თვის დღე',
  'deadlines.lastDay': 'თვის ბოლო დღე',
  'deadlines.everyDay': 'ყოველთვე, {day} რიცხვში',
  'deadlines.everyLastDay': 'ყოველთვე, ბოლო დღეს',
  'deadlines.field.note': 'შენიშვნა',
  'deadlines.field.responsible': 'ვინ არის პასუხისმგებელი',
  'deadlines.responsible.managers': 'ყველა, ვინც ფინანსებს მართავს',
  'deadlines.responsible.roles': 'როლი',
  'deadlines.responsible.people': 'ადამიანი',
  'deadlines.field.reminders': 'შეხსენება',
  'deadlines.remind.7': 'კვირით ადრე',
  'deadlines.remind.3': '3 დღით ადრე',
  'deadlines.remind.1': 'წინა დღეს',
  'deadlines.remind.0': 'იმავე დღეს',
  'deadlines.noReminders': 'შეხსენების გარეშე',
  'deadlines.switchOff': 'გამორთვა',
  'deadlines.switchedOff': 'ვადა გამოირთო',
  'deadlines.created': 'ვადა დაემატა',
  'deadlines.updated': 'ვადა შეინახა',
  'deadlines.suggestions': 'შემოთავაზებები',
  'deadlines.suggestionsHint': 'ხშირი ყოველთვიური ფინანსური საქმეები. სანამ დაეყრდნობით, დღე ბუღალტერთან დააზუსტეთ: ეს კანონით დადგენილი ვადები არ არის.',
  'deadlines.suggest.statement': 'წინა თვის ამონაწერის ჩამოტვირთვა და შენახვა',
  'deadlines.suggest.reconcile': 'ბანკის ჩარიცხვების შედარება რეესტრთან',
  'deadlines.suggest.invoices': 'საგადასახადო ანგარიშ-ფაქტურების გამოწერა rs.ge-ზე',
  'deadlines.suggest.refunds': 'მომლოდინე დაბრუნებების განხილვა',
  'deadlines.addSuggestion': 'დამატება',
  'deadlines.next': 'მომდევნო ვადები',
  'deadlines.seeAll': 'ყველა ვადა',
  'deadlines.noneUpcoming': 'ამჟამად ვადები არ არის.',
  'deadlines.setUp': 'ვადების დაყენება',
  'deadlines.close.button': 'თვის დახურვა',
  'deadlines.close.confirmTitle': 'დავხუროთ {month}?',
  'deadlines.close.confirmBody': 'მისი ხელფასები და ეს ჩამონათვალი გაიყინება, სანამ მფლობელი ან ადმინისტრატორი ხელახლა არ გახსნის.',
  'deadlines.close.done': 'თვე დაიხურა',
  'deadlines.close.closedBy': 'დახურა {name}, {date}. მისი ხელფასები და ჩამონათვალი გაყინულია.',
  'deadlines.close.tasksFirst': 'თვის დასახურად ყველა დავალება მონიშნეთ შესრულებულად ან გამოტოვებულად.',
  'deadlines.close.reopenButton': 'თვის ხელახლა გახსნა',
  'deadlines.close.reopenTitle': '{month} — ხელახლა გახსნა',
  'deadlines.close.reopenReason': 'მიზეზი',
  'deadlines.close.reopenHint': 'ინახება აუდიტის ჟურნალში.',
  'deadlines.close.reopened': 'თვე ხელახლა გაიხსნა',
  'deadlines.close.reopenedBy': 'ხელახლა გახსნა {name}, {date}: {reason}',
  'deadlines.close.afterClose': 'ონლაინ გადახდები, რომლებიც თვის დახურვის შემდეგ დადასტურდა',
  'deadlines.close.afterCloseHint': 'ბანკმა ეს გადახდები ამ თვით დაათარიღა და დაადასტურა მას შემდეგ, რაც თვე დაიხურა. თითოეულთან ჩანს თარიღი, რომლითაც აღირიცხა.',
  'deadlines.closing': 'თვის დახურვის წესი',
  'deadlines.closing.hint': 'დახურულ თვეში ხელფასები და ეს ჩამონათვალი იყინება. ბუღალტერი, მფლობელი და ადმინისტრატორი თვეს ხურავენ, როცა ის დასრულდება და ყველა დავალება შესრულებული ან გამოტოვებულია; ხელახლა გახსნა მფლობელსა და ადმინისტრატორს შეუძლიათ.',
  'deadlines.late.label': 'როცა ბანკი ადასტურებს ონლაინ გადახდას, რომელიც დახურული თვით არის დათარიღებული',
  'deadlines.late.FLAG': 'დარჩეს თავისი თარიღით და მოინიშნოს დახურულ თვეში',
  'deadlines.late.NEXT_OPEN_MONTH': 'აღირიცხოს შემდეგი ღია თვის დასაწყისით',
  'deadlines.late.saved': 'შენახულია',
};
